<template>
    <div id="bigData" class="bigData">
        <Amap ref="map" @maskerClick="onMasker" @AmapLoaded="handleAmapLoadingEvent" />
        <SensorList />
        <Weather />
        <DataPolice />
        <bdHeader />
        <div
            class="log-foucsMap foucsMap"
            :class="{ active: $store.state.map.isFoucs }"
            @click="foucsMap"
        >
            缩放至园区
        </div>
        <div
            class="log-foucsMap satelliteMap"
            :class="{ active: $store.state.map.isSatellite }"
            @click="satelliteMap"
        >
            卫星模式
        </div>
        <!-- 缩放 -->
        <div class="iconFullScreen">
            <img
                @click="fullScreen"
                :src="
                    !isFullScreen
                        ? require('../assets/fullscreen-expand.png')
                        : require('../assets/fullscreen-shrink.png')
                "
            />
        </div>
        <envChart />
        <Monitor />
        <Dynamic @handleChange ="handleChange"  v-if="dynamicFlag"/>
        <demo @handleChange ="handleChange" @newsSingleChange="newsSingleChange" @showAllNewsDialog="showAllNewsDialog" v-else ></demo>

        <!--    彈出框-->
        <div class="news-popup" v-if="news_all_dialog_visible">
            <div class="news-popup-header">
                <div class="news-popup-title">涉农资讯</div>
                <img
                    class="images-popup-close"
                    src="../assets/close.png"
                    alt="close.png"
                    @click="news_all_dialog_visible=!news_all_dialog_visible"
                />
            </div>
            <div class="news-popup-content">
                <template v-if="showNewsTableFlag">

                 <Table  highlight-row ref="currentRowTable"  @on-row-click = 'newsRowClick' :columns="news_table_columns" :data="news_data_list"></Table>
                </template>
                <template v-else>
                    <div>
                        <span class="news-popup-content-single-title">{{news_single_data.title}}</span>
                        <span class="news-popup-content-single-btn" @click="NewsCancel" > <Icon type="ios-arrow-back" />返回</span>

                    </div>

                    <div class="news-popup-content-single-date news-popup-content-single-title"><i data-v-261f9c3e="" class="icon ivu-icon ivu-icon-ios-paper-outline"></i>&nbsp;<i data-v-261f9c3e="" class="icon ivu-icon ivu-icon-md-calendar"></i>{{news_single_data.publish_time}}</div>
                    <div class="news-popup-content-single-content">
                        {{news_single_data.data}}

                    </div>
                </template>
            </div>
        </div>





        <Trace @check-more-pictures="handleImagesPopupOpenEvent" />
        <!-- 加载样式 -->
        <Spin fix v-show="loading">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>Loading...</div>
        </Spin>
        <!-- 提示 -->
        <div class="mask" v-if="isShowTips && !loading">
            <img class="tips" src="../assets/tip_bubbles.png" @click="closeTipBubble" />
        </div>
        <!-- 查看图片 -->
        <div class="images-popup" v-if="imagesPopup">
            <div class="images-popup-header">
                <div class="images-popup-title">查看图片</div>
                <img
                    class="images-popup-close"
                    src="../assets/close.png"
                    alt="close.png"
                    @click="handleImagesPopupCloseEvent"
                />
            </div>
            <div class="images-popup-content">
                <!-- 轮播 -->
                <Carousel class="images-popup-content-carousel" v-model="currentFarmIamges">
                    <CarouselItem
                        class="images-popup-list"
                        v-for="(item, index) in farmImages"
                        :key="index"
                    >
                        <img class="carousel-image" :src="item" />
                    </CarouselItem>
                </Carousel>
                <!-- 缩略图 -->
                <div class="thumbnail">
                    <img
                        class="thumbnail-image"
                        :src="item"
                        v-for="(item, index) in farmImages"
                        :key="index"
                        @click="switchCurrentImage(index)"
                    />
                </div>
            </div>
        </div>
        <!-- 设备信息 -->
        <deviceDetails v-if="deviceInfo && deviceInfo.monitor_type != 5" @closeMask="offMask" :info="deviceInfo"></deviceDetails>
        <cameraDrawer v-if="deviceInfo && deviceInfo.monitor_type == 5" @closeMask="offMask" :info="deviceInfo"></cameraDrawer>
    </div>
</template>

<script>
import Amap from "../components/amap";
import SensorList from "../components/sensorList";
import Weather from "../components/weather";
import DataPolice from "../components/dataPolice";
import bdHeader from "../components/bdHeader";
import envChart from "../components/envChart";
import Monitor from "../components/monitor";
import Dynamic from "../components/dynamic";
import Trace from "../components/trace/trace";
import deviceDetails from "../components/deviceDetails";
import cameraDrawer from "../components/cameraDrawer.vue";
import demo from "../components/news.vue";
import LocalStorge from "@/utils/localStorge";
import localStorge from "@/utils/localStorge";
import {getNewsSingle} from "@/api/agri";

export default {
    name: "bigData",
    data() {
        return {
            isShowTips: true,
            deviceInfo: false,
            amapLoaded: false,
            imagesPopup: false,
            farmImages: [],
            currentFarmIamges: 0,
            isFullScreen: false,
            dynamicFlag:false,
            news_all_dialog_visible:false,
            news_single_dialog_visible:false,
            news_data_list:[],
            news_table_columns:  [
                {
                    type: 'index',
                    width: 70,
                    align: 'center',
                    title:'序号'
                },
                {
                    title: '标题',
                    key: 'title'
                },
                {
                    title: '时间',
                    width: 120,
                    key: 'publish_time'
                },

            ],
            showNewsTableFlag:true,
            news_single_data:{
                data:'',
                publish_time:'',
                redirect_url:""
            }
        };
    },
    created() {
        // 设置全局farm_id
        this.$store.commit("setFarmId", {
            farmId: Number(this.$route.query.farmId) || 6,
        });

    },
    mounted() {
        // 是否显示提示信息
        this.isShowTips = localStorage.getItem("isShowTips") === "false" ? false : true;
        // 获取当前屏幕占比并提示
        if (!this.isScreen()) {
            this.$Message.warning({
                content: "您当前为非16:9或4:3的屏幕，使用16:9或4:3的屏幕获得最佳体验。",
                duration: 3,
            });
        }
        if(localStorage.getItem('dynamicFlag')){
            this.dynamicFlag = localStorage.getItem('dynamicFlag')==1?true:false
        }
    },
    computed: {
        loading() {
            if (this.amapLoaded) {
                return false;
            } else {
                return true;
            }
        },
    },
    methods: {
        onMasker(e) {
            this.deviceInfo = e;
        },
        offMask() {
            this.deviceInfo = false;
        },
        satelliteMap() {
            this.$refs.map.showSatelliteIcon();
        },
        foucsMap() {
            this.$refs.map.showIcon();
        },
        handleAmapLoadingEvent(flag) {
            this.amapLoaded = flag;
        },
        // 全屏
        fullScreen() {
            //  TODO 在执行获取窗口当前是否在全屏模式
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().then(() => {
                    this.isFullScreen = true;
                });
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen().then(() => {
                        this.isFullScreen = false;
                    });
                }
            }
        },
        // 关闭提示泡泡
        closeTipBubble() {
            this.isShowTips = false;
            localStorage.setItem("isShowTips", this.isShowTips);
        },
        // 开启图片展示弹窗
        handleImagesPopupOpenEvent(status) {
            this.imagesPopup = status;
            if (status === true) {
                this.farmImages = this.$store.getters["trace/getFarmMessage"].pictures;
            }
        },
        // 关闭图片展示弹窗
        handleImagesPopupCloseEvent() {
            this.imagesPopup = false;
        },
        // 切换当前显示图片
        switchCurrentImage(index) {
            this.currentFarmIamges = index;
        },
        // 屏幕比例是否正确
        isScreen() {
            const screenHeight = window.screen.height;
            const screenWidth = window.screen.width;
            if (!(screenWidth / screenHeight === 16 / 9 || screenWidth / screenHeight === 4 / 3)) {
                return false;
            }
            return true;
        },
        handleChange(){
            this.dynamicFlag = !this.dynamicFlag
            localStorage.setItem('dynamicFlag',this.dynamicFlag?1:0)
        },
        showAllNewsDialog(data){
            this.news_all_dialog_visible = !this.news_all_dialog_visible
            this.news_data_list = data

        },
        async newsRowClick(row) {
            const {data:data}= await getNewsSingle(row.redirect_url)
              this.showNewsTableFlag = !this.showNewsTableFlag
            // 强制视图更新
            this.$forceUpdate();
            if(data.msg=='ok'){
                this.$set(this.news_single_data, 'title', row.title);
                this.$set(this.news_single_data, 'publish_time', row.publish_time);
                this.$set(this.news_single_data, 'data', data.data);
               console.log(this.news_single_data.data,this.showAllNewsDialog,this.showNewsTableFlag,9090)
            }


        },
        async newsSingleChange(row,data_list) {
            this.news_data_list = data_list
            this.news_all_dialog_visible = true
            this.showNewsTableFlag = false
            this.news_single_data.title = row.title
            this.news_single_data.publish_time = row.publish_time
            const {data: data} = await getNewsSingle(row.redirect_url)
            if (data?.msg == 'ok') {
                this.news_single_data.data = data.data
                console.log(this.news_single_data.data, 9090)
            }
        },
        NewsCancel(){
            this.showNewsTableFlag  = !this.showNewsTableFlag

        }
    },
    components: {
        Amap,
        SensorList,
        Weather,
        DataPolice,
        bdHeader,
        envChart,
        Monitor,
        Dynamic,
        Trace,
        deviceDetails,
        cameraDrawer,
        demo
    },
};
</script>

<style scoped>
.bigData {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "微软雅黑", Arial, sans-serif;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.log-foucsMap {
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
}

.log-foucsMap.active {
    color: #968f85;
}

.foucsMap {
    position: absolute;
    left: calc(26.615vw + 40px);
    bottom: calc((100% - 80px) / 3 + 30px);
    border: 1px solid;
    padding: 4px 4px;
    border-radius: 2px;
    cursor: pointer;
    line-height: 1;
}

.satelliteMap {
    position: absolute;
    left: calc(26.615vw + 130px);
    bottom: calc((100% - 80px) / 3 + 30px);
    border: 1px solid;
    padding: 4px 4px;
    border-radius: 2px;
    cursor: pointer;
    line-height: 1;
}

.iconFullScreen {
    position: absolute;
    right: calc(26.615vw + 40px);
    bottom: calc((100% - 80px) / 3 + 30px);
    height: 32px;
    width: 32px;
}

.iconFullScreen img {
    width: 100%;
    height: 100%;
}

.mask {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.tips {
    display: block;
    position: absolute;
    right: calc(26.615vw + 50px);
    bottom: calc((100% - 80px) / 3 - 60px);
}

.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.images-popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56vw;
    height: 30vw;
    border: 0.05vw solid rgb(1, 186, 225);
    box-shadow: 0 0 0.1vw 0.1vw rgba(1, 186, 225, 0.6);
    z-index: 10;
}

.images-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 15, 25, 0.9);
    width: 100%;
    height: 2vw;
    padding: 0 0.5vw;
}

.images-popup-content {
    position: relative;
    background-color: rgba(0, 37, 61, 0.9);
    width: 100%;
    height: calc(100% - 2vw);
}

.images-popup-title {
    font-size: 0.6vw;
}

.images-popup-close {
    width: 0.8vw;
    height: 0.8vw;
}

.images-popup-close:hover {
    cursor: pointer;
}

.images-popup-content-carousel {
    position: relative;
    width: 100%;
    height: calc(100% - 5vw);
    padding-top: 1vw;
    overflow: hidden;
}

.images-popup-list {
    position: relative;
    width: 100%;
    height: 100%;
}


.news-popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56vw;
    height: 30vw;
    border: 0.05vw solid rgb(1, 186, 225);
    box-shadow: 0 0 0.1vw 0.1vw rgba(1, 186, 225, 0.6);
    z-index: 10;
}

.news-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 15, 25, 0.9);
    width: 100%;
    height: 2vw;
    padding: 0 0.5vw;
}

.news-popup-content {
    position: relative;
    background-color: rgba(0, 37, 61, 0.9);
    width: 100%;
    height: calc(100% - 2vw);
    overflow: auto;
    font-size: 0.7vw;
    padding:2vh;
    color:#aaa;
}
.news-popup-content-single-content{
    font-size: 0.9vw;
    text-indent: 2em;
}
.news-popup-content-single-title{
    font-size: 1vw;
}
.news-popup-content-single-btn{
    float: right;
    background:#3b4455;
    padding:0.5vh;
    z-index: 99;
    cursor: pointer;
}
.news-popup-content-single-date{
    margin:1vh;
}
/* 自定义滚动条样式 */
.news-popup-content::-webkit-scrollbar {
    width: 12px;  /* 宽度 */
    background-color: #bbb; /* 滚动条背景 */
}

/* 自定义滚动条滑块样式 */
.news-popup-content::-webkit-scrollbar-thumb {
    background-color: #333; /* 滑块颜色 */
    border-radius: 6px;     /* 圆角 */
}

/* 自定义滚动条轨道样式 */
.news-popup-content::-webkit-scrollbar-track {
    background-color: #515a6e; /* 轨道颜色 */
}

.scrollable-container .content {
    padding: 10px;
}
/deep/ .ivu-table{
    background-color: #09243C!important;
    border: none!important;
}
/deep/ .ivu-table-wrapper-with-border{
    border:none!important;
}
/deep/ .ivu-table th{
    background: linear-gradient(0deg, #062A41 1%, #0A324D 99%)!important;
    border-right: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    border-top: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    border-bottom: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    font-size: 0.8rem!important;
    color: rgba(250, 250, 250, 0.6)!important;
}
/deep/ .ivu-table tr{
    background: #041c34!important;
    border-right: none!important;
    border-top: none!important;
    border-bottom: none!important;
    font-size: 0.8rem!important;
    color: rgba(250, 250, 250, 0.6)!important;
}
/deep/ .ivu-table tr td{
    background: #041c34!important;
    border-right: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    border-top: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    border-bottom: 0.05rem solid rgba(255, 255, 255, 0.15)!important;
    font-size: 0.8rem!important;
    color: #65BEF6!important;
}
/deep/ .ivu-table-row:hover {
    cursor: pointer;
}
.news-popup-title {
    font-size: 1vw;
}


.carousel-image {
    display: block;
    margin: 0 auto;
    width: 60%;
    height: 100%;
}

.thumbnail {
    height: 5vw;
    display: flex;
    align-items: center;
}

.thumbnail-image {
    height: 4vw;
    width: 6vw;
    margin: 0 0.6vw;
}

.thumbnail-image:hover {
    cursor: pointer;
}
</style>
